import { render, staticRenderFns } from "./red-packet.vue?vue&type=template&id=8e85e77a&scoped=true"
import script from "./red-packet.vue?vue&type=script&lang=js"
export * from "./red-packet.vue?vue&type=script&lang=js"
import style0 from "./red-packet.vue?vue&type=style&index=0&id=8e85e77a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e85e77a",
  null
  
)

export default component.exports